import { useEffect, useState } from "react";
import { Play, Trophy, UserCircle } from "@phosphor-icons/react";
import client from "../lib/api";
import PricingDemoClip from "./PricingDemoClip";

function daysAgo(iso) {
  if (!iso) return "";
  const d = Math.max(0, Math.round((Date.now() - new Date(iso)) / 86400000));
  return d === 0 ? "today" : d === 1 ? "yesterday" : `${d}d ago`;
}

// Social proof beside the /start form: the latest REAL first-load win from the Win Wall
// (nothing is faked — if no carrier has posted a win yet, the founder line shows instead).
export function StartProofLine({ win }) {
  if (win) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-[#00D4AA]/30 bg-[#00D4AA]/[0.06] p-3" data-testid="start-proof-win">
        <Trophy size={20} weight="fill" className="text-[#00D4AA] shrink-0 mt-0.5" />
        <div className="text-sm leading-snug">
          <div className="text-white font-semibold">{win.company || win.first_name || "New owner-operator"} booked their first load {daysAgo(win.booked_at)}</div>
          <div className="text-neutral-400 text-xs mt-0.5">
            {win.lane_from && win.lane_to ? `${win.lane_from} → ${win.lane_to}` : "First load"}{win.equipment ? ` · ${win.equipment}` : ""}
            {win.days_from_active != null ? ` · ${win.days_from_active} days after authority went active` : ""}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-3" data-testid="start-proof-founder">
      <UserCircle size={20} weight="fill" className="text-[#FF9764] shrink-0 mt-0.5" />
      <div className="text-sm leading-snug">
        <div className="text-white font-semibold">Founder-run — not a faceless software team</div>
        <div className="text-neutral-400 text-xs mt-0.5">Built by Mikele, a carrier going through the new-authority process himself (Freight Trans LLC). You get his direct line, and he sets your workflows up with you.</div>
      </div>
    </div>
  );
}

export default function StartProof({ compact = false, autoplay = false }) {
  const [win, setWin] = useState(null);
  const [open, setOpen] = useState(autoplay);
  useEffect(() => {
    client.get("/public/wins/recent?limit=1").then((r) => setWin((r.data?.wins || [])[0] || null)).catch(() => {});
  }, []);
  if (compact) {
    return (
      <div className="space-y-3 mb-6 lg:hidden" data-testid="start-proof-compact" data-autoplay={autoplay ? "1" : "0"}>
        {!autoplay && <StartProofLine win={win} />}
        {!open ? (
          <button type="button" onClick={() => setOpen(true)} className="w-full inline-flex items-center justify-center gap-2 rounded-xl border border-white/10 py-2.5 text-sm text-neutral-200 hover:border-white/25" data-testid="start-proof-watch">
            <Play size={14} weight="fill" className="text-[#FF5A1F]" /> Watch the 12-second demo — real screens
          </button>
        ) : (
          <PricingDemoClip className="relative z-10" testId="start-demo-clip" />
        )}
        {autoplay && <StartProofLine win={win} />}
      </div>
    );
  }
  return (
    <div className="space-y-4" data-testid="start-proof">
      <PricingDemoClip className="relative z-10 max-w-[260px]" testId="start-demo-clip" />
      <StartProofLine win={win} />
    </div>
  );
}
